import React, { lazy } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import './App.css'

const MintingPage = lazy(() => import('@/pages/mintingPage'));
// const WhitelistPage = lazy(() => import('@/pages/whitelistPage'));
// const PasscodePage = lazy(() => import('@/pages/passcodePage'));
const AuthLayout = lazy(() => import('@/pages/authLayout'));

const routers = [
    {
        path: '/passport',
        element: <MintingPage />
    },
    {
        path: '/passport/admin',
        element: <AuthLayout />,
        // children: [
        //     {
        //         path: '/admin/whitelist',
        //         element: <WhitelistPage />
        //     },
        //     {
        //         path: '/admin/passcode',
        //         element: <PasscodePage />
        //     }
        // ]
    }
];

const appRouter = createBrowserRouter(routers);

function App() {
    return (
        <RouterProvider router={appRouter} />
    );
}

export default App;